const React = require("react");
const noop = require("mn-utils/noop");
const Ripple = require("../../../../../Ripple");
const withState = require("../../../../../../../utils/withState");
const AdminCellBase = require("../HeadCellAdminWrapper");

const ListItem = ({name, active, onClick = noop, index}) => {
  return (
    <Ripple
      className={
        `w h37 layoutRow jcSB aiC pl19 pr8 bxzBorderBox f12 c2 td bgFAFAFA.hasBg`
        + ((index + 1) % 2 !== 0 ? ' hasBg' : '')
      }
      onClick={onClick}
    >
      <span className="f12 fw7">{name}</span>
      <div className="w12 h12 rlv">
        <div className="w h abs st0 sl0 b1 bs bc73757A r50%" />
        <div className={
          `w8 h8 abs st2 sl2 bgTransparent bg0.active r50%`
          + (active ? ' active' : '')
        } />
      </div>
    </Ripple>
  )
}

const ListDisplay = withState((setState, self, onMount) => {
  let integer = 0;
  const id = `${(self.props.filters || {}).name}TableFilter`;
  const toggleWindow = self.props.toggleWindow || noop;

  onMount(() => {
    const id = (self.filters || {}).name;

    const hasSomeParentWithId = (element) => {
      if (element.id && element.id.split(' ').indexOf(id)>=0) return true;
      return element.parentNode && hasSomeParentWithId(element.parentNode);
    }

    const onWindowClick = (e) => {
      if (integer === 0) {
        integer++;
        return;
      }

      if (!hasSomeParentWithId(e.target)) toggleWindow();
    }

    window.addEventListener('click', onWindowClick);
    return () => window.removeEventListener('click', onWindowClick);
  })

  return (state, props) => {
    const {
      cellRef,
      filters = {},
      handleChangeFilter = noop,
      currentFilterValue
    } = props;

    const rects = cellRef.current
      ? cellRef.current.getBoundingClientRect()
      : {width: 0, height: 0, y: 0, x: 0};

    return (
      <div id={id} className={`w abs sb0 sl0 z1000`}>
        {/*<div*/}
        {/*  className="w h abs st0 sl0"*/}
        {/*  onClick={toggleWindow}*/}
        {/*/>*/}
        <div
          className="w filterWindow abs bgF bxsh4y2c0000004f"
          // style={{width: rects.width, top: rects.height + rects.y, left: rects.x}}
        >
          {filters.list && filters.list.map((el, i) => (
            <ListItem
              key={i}
              index={i}
              name={el.name}
              active={currentFilterValue
                ? currentFilterValue === el.id
                : el.id === 'all'
              }
              onClick={() => {
                handleChangeFilter({[filters.name]: el.id !== 'all' ? el.id : ''});
                toggleWindow()
              }}
            />
          ))}
        </div>
      </div>
    )
  }
}, {

})


module.exports = withState((setState, self) => {
  const ref = React.createRef();

  const toggleWindow = () => {
    setState({showWindow: !self.state.showWindow});
  }

  return (state, props) => {
    const {children, self = {}, filters = {}, handleChangeFilter, className, ...restProps} = props;

    const showWindow = state.showWindow;

    const filter = (self.state || {}).filter;
    const filterName = filters.name;
    const currentFilterValue = filter[filterName];

    const filterItemDisplayName = currentFilterValue && filters.list
      ? filters.list.find((el) => el.id === currentFilterValue)
      : {};

    const selectedFilterDisplayName = filterItemDisplayName.nameHeadDisplay || filterItemDisplayName.name;

    return (
      <AdminCellBase
        {...restProps}
        cellRef={ref}
        className={
          `(w|tc)>.filterBtn 
          (abs|st50%|sr8|xY-50%rx180deg|dn)>.cellCaret (dB)>.cellCaret>svg (xY-50%).windowShown>.cellCaret
          (rlb9):first-child>.filterWindow (rrb9):last-child>.filterWindow`
          + (className ? ` ${className}` : '')
          + (showWindow ? ` windowShown` : '')
        }
      >
        {filters.list && filters.list.length ? (
          <Ripple className="filterBtn" onClick={toggleWindow}>
            <span dangerouslySetInnerHTML={{__html: `${children}${currentFilterValue ? `<br/>(${selectedFilterDisplayName})` : ''}`}} />
            <div className="cellCaret">
              <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.75 6L10 4.7772L5 -1.0133e-06L9.68256e-07 4.7772L1.25 6L5 2.4L8.75 6Z" fill="white"/>
              </svg>
            </div>
          </Ripple>
        ) : (
          <span>{children}</span>
        )}
        {showWindow && (
          <ListDisplay
            cellRef={ref}
            filters={filters}
            currentFilterValue={currentFilterValue}
            handleChangeFilter={handleChangeFilter}
            toggleWindow={toggleWindow}
          />
        )}
      </AdminCellBase>
    )
  }
}, {})
